import React, { useEffect, useState } from 'react'
import Header from './header'
import Footer from './footer'
import axios from 'axios'
import cookies from 'react-cookies'
import { Form } from 'antd'
import { auth0Roles, strapiURL } from '../../config'
import { useDispatch, useSelector } from 'react-redux'
import { SetLoader } from '../../redux/actions/loader'
import {
  logout,
  setProfileData,
  setNamedUserEmployerProfiles,
} from '../../redux/actions/user'
import SEO from '../pageComponents/common/helmetCompont'
import CandidateSignUpModal from '../Modals/candidateSignup'
import CandidateLoginModal from '../Modals/candidateLogin'
import globalData from '../../../globalData.json'

const Wrapper = ({
  privateRoute = false,
  children,
  hideCTA,
  title,
  description,
  metaKeywords,
  data,
  employerFacing,
  location,
  sourceKey,
}) => {
  let user = cookies.load('user')
  let userRole = cookies.load('userRole')
  let selectedNamedUserEmployerId = cookies.load('selectedNamedUserEmployerId')

  const dispatch = useDispatch()
  const loader = useSelector(state => state.loader)
  const profileData = useSelector(state => state.user.profileData)
  const namedUserEmployerProfiles = useSelector(
    state => state.user.namedUserEmployerProfiles
  )

  const [loading, setLoading] = useState(false)
  const [contentLoading, setContentLoading] = useState(true)
  const [loginModal, setLoginModal] = useState(false)
  const [signupModal, setSignUpModal] = useState(false)
  const [loginForm] = Form.useForm()
  const [signUpForm] = Form.useForm()

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(location?.search)
    const source = urlSearchParams.get('utm_source')

    if (!privateRoute) {
      setContentLoading(false)
      if (source === 'email' && (!user || !userRole)) {
        const directUrl = localStorage.getItem('redirect-url')
        if (!directUrl) {
          localStorage.setItem('redirect-url', location.href)
        }
        openLoginModal()
      }
      return
    }
    if (!user || !userRole || !profileData) {
      if (source === 'email') {
        const directUrl = localStorage.getItem('redirect-url')
        if (!directUrl) {
          localStorage.setItem('redirect-url', location.href)
        }
        openLoginModal()
      } else {
        dispatch(logout())
      }
    }

    if (
      privateRoute &&
      employerFacing &&
      user &&
      userRole !== auth0Roles.Employer.id &&
      userRole !== auth0Roles.NamedUser.id
    ) {
      dispatch(logout('Please login with a employer or named user account.'))
    }
    if (
      !employerFacing &&
      privateRoute &&
      user &&
      userRole !== auth0Roles.Member.id
    ) {
      dispatch(logout('Please login with a candidate account'))
    }

    if (
      userRole === auth0Roles.NamedUser.id &&
      (!namedUserEmployerProfiles || !selectedNamedUserEmployerId)
    ) {
      dispatch(logout())
    }

    if (userRole === auth0Roles.Employer.id) {
      if (!profileData) {
        loadEmployerProfile()
      }
    } else if (userRole === auth0Roles.Member.id) {
      if (!profileData) {
        loadCandidateProfile()
      }
    } else if (userRole === auth0Roles.NamedUser.id) {
      if (!namedUserEmployerProfiles) {
        loadNamedUserProfile()
      } else {
        if (selectedNamedUserEmployerId) {
          if (!profileData.id === selectedNamedUserEmployerId) {
            const selectedEmployer = namedUserEmployerProfiles.find(
              profile => profile.id === selectedNamedUserEmployerId
            )
            dispatch(setProfileData(selectedEmployer))
          }
        } else {
          dispatch(setProfileData(namedUserEmployerProfiles[0]))
          cookies.save('selectedNamedUserEmployerId', profileData.id, {
            path: '/',
            maxAge: 518400,
          })
        }
      }
    }
    setContentLoading(false)
  }, [
    location.search,
    privateRoute,
    user,
    userRole,
    namedUserEmployerProfiles,
    profileData,
    selectedNamedUserEmployerId,
  ])

  const loadCandidateProfile = () => {
    dispatch(SetLoader(true))
    axios
      .post(strapiURL + '/candidate-profiles/get-profile', {
        username: user?.username,
      })
      .then(res => {
        dispatch(setProfileData(res.data))
        dispatch(SetLoader(false))
      })
      .catch(err => {
        dispatch(SetLoader(false))
        console.log(err)
      })
  }

  const loadEmployerProfile = () => {
    dispatch(SetLoader(true))
    axios
      .post(strapiURL + '/employers/profile', {
        username: user?.username,
      })
      .then(res => {
        dispatch(setProfileData(res.data))
        dispatch(SetLoader(false))
      })
      .catch(err => {
        dispatch(SetLoader(false))
        console.log(err)
      })
  }

  const loadNamedUserProfile = () => {
    dispatch(SetLoader(true))
    axios
      .post(strapiURL + '/named-users/getNamedUsers', {
        username: user?.username,
      })
      .then(res => {
        const namedUsers = res.data
        const namedUserProfiles = namedUsers?.map(user => user.employer)

        let profile
        if (namedUserProfiles.length) {
          if (selectedNamedUserEmployerId) {
            profile = namedUserProfiles.find(
              profile => profile.id === selectedNamedUserEmployerId
            )
          } else {
            profile = namedUserProfiles[0]
          }
        }

        cookies.save('selectedNamedUserEmployerId', profile.id, {
          path: '/',
          maxAge: 518400,
        })
        dispatch(setProfileData(profile))
        dispatch(setNamedUserEmployerProfiles(namedUserProfiles))
        dispatch(SetLoader(false))
      })
      .catch(err => {
        dispatch(SetLoader(false))
        console.log(err)
      })
  }

  const loadUserProfile = () => {
    if (!user || !userRole) {
      return
    }

    if (userRole === auth0Roles.Employer.id) {
      loadEmployerProfile()
    } else if (userRole === auth0Roles.Member.id) {
      loadCandidateProfile()
    } else if (userRole === auth0Roles.NamedUser.id) {
      loadNamedUserProfile()
    }
  }

  const setUserProfile = profile => {
    dispatch(setProfileData(profile))
  }

  const closeLoginModal = () => {
    setLoading(false)
    setLoginModal(false)
    loginForm.resetFields()
  }

  const closeSignUpModal = () => {
    setLoading(false)
    setSignUpModal(false)
    signUpForm.resetFields()
  }
  const openLoginModal = () => {
    closeSignUpModal()
    setLoginModal(true)
  }
  // const openSignupModal = () => {
  //   closeLoginModal()
  //   setSignUpModal(true)
  // }

  return (
    <>
      <SEO
        title={title}
        data={data}
        description={description}
        sourceKey={sourceKey}
        metaKeywords={metaKeywords}
      />
      <Header
        closeLoginModal={closeLoginModal}
        openLoginModal={openLoginModal}
        // openSignupModal={openSignupModal}
        closeSignUpModal={closeSignUpModal}
        loginModal={loginModal}
        signupModal={signupModal}
        modalLoading={loading}
        setModalLoading={setLoading}
        globalData={globalData}
        loginForm={loginForm}
        signUpForm={loginForm}
        userProfile={profileData}
        dispatch={dispatch}
        loader={loader?.loading}
        employerFacing={employerFacing}
        user={user}
        userRole={userRole}
        location={location}
      />
      {!contentLoading &&
        React.cloneElement(children, {
          userProfile: profileData,
          setUserProfile: setUserProfile,
          loadUserProfile: loadUserProfile,
          user: user,
          closeLoginModal: closeLoginModal,
          openLoginModal: openLoginModal,
          // openSignupModal: openSignupModal,
          closeSignUpModal: closeSignUpModal,
          loginModal: loginModal,
          signupModal: signupModal,
          modalLoading: loading,
          setModalLoading: setLoading,
          globalData: globalData,
          loginForm: loginForm,
          signUpForm: loginForm,
          userRole: userRole,
          location: location,
        })}

      {!contentLoading && (
        <Footer
          globalData={globalData}
          userProfile={profileData}
          user={user}
          hideCTA={hideCTA}
          closeLoginModal={closeLoginModal}
          openLoginModal={openLoginModal}
          // openSignupModal={openSignupModal}
          closeSignUpModal={closeSignUpModal}
          loginModal={loginModal}
          signupModal={signupModal}
          modalLoading={loading}
          loginForm={loginForm}
          signUpForm={loginForm}
          setModalLoading={setLoading}
          userRole={userRole}
          location={location}
        />
      )}
      <CandidateLoginModal
        form={loginForm}
        loading={loading}
        setLoading={setLoading}
        closeHandler={closeLoginModal}
        modalOpen={loginModal}
        // openSignupModal={openSignupModal}
      />
      <CandidateSignUpModal
        form={signUpForm}
        loading={loading}
        setLoading={setLoading}
        closeHandler={closeSignUpModal}
        modalOpen={signupModal}
      />
    </>
  )
}
export default Wrapper
